const EditIcon = () => {
    return (
        <i className="fa-solid fa-pencil"></i>
    )
}

export default EditIcon;